<div *ngIf="this.show" fxFill fxLayout="column" fxLayoutAlign="start center">
  <!-- HEADER -->
  <app-header-noauth
    [onfido]="true"
    class="appHeader appHeader--sticky appHeader--noauth"
    [hideLanguage]="true"
  ></app-header-noauth>

  <div class="wrapper wrapper--noauth" fxLayoutAlign="center center" fxFlex="100%">
    <div fxFlex="100" class="wrapper__content">
      <mat-card fxFlex="100">
        <div class="content">
          <h2 class="title" translate>videoselfing.landing.checkbox.title</h2>
          <p class="consent-text" translate>videoselfing.landing.checkbox.one</p>
          <p class="consent-text" translate>videoselfing.landing.checkbox.two</p>
          <div class="button-container">
            <button class="consent-button" id="acceptButton" mat-flat-button color="accent" (click)="onClickAccept()">
              {{ 'videoselfing.landing.button' | translate }}
            </button>
            <button
              class="consent-button"
              id="cancelButton"
              mat-stroked-button
              color="accent"
              (click)="onClickCancel()"
            >
              {{ 'videoselfing.landing.button.cancel' | translate }}
            </button>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
